/**
 *
 * Supported names
 */
export const HIDDEN = 'hidden';
